var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("ProjectPlanTemplateEditor", {
        attrs: { viewModel: _vm.projectPlanTemplateEditor },
        on: {
          "create-template":
            _vm.handleCreateCorporateProjectPlanTemplateCommand,
          "update-template":
            _vm.handleUpdateCorporateProjectPlanTemplateCommand,
        },
      }),
      _vm._v(" "),
      _c("CorporateNavigation", { attrs: { ActivePage: "strategy" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-success",
                        staticStyle: { padding: "0.7em 2em" },
                        attrs: { type: "button" },
                        on: { click: _vm.showProjectPlanTemplateCreator },
                      },
                      [_vm._v("Create a template")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "mt-3" }, [
                _c(
                  "table",
                  { staticClass: "table table-bordered table-hover" },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.rm.Templates, function (t) {
                        return _c("tr", { key: t.Id }, [
                          _c("td", [
                            _vm._v(
                              "\n                            " + _vm._s(t.Name)
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                            " +
                                _vm._s(t.Description) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(t.Granularity)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(t.Denomination)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(t.DurationInMonths)),
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-center" }, [
                            _vm._v(_vm._s(t.PlanningHorizonInYears)),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c("div", { staticClass: "dropdown" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary dropdown-toggle",
                                  attrs: {
                                    type: "button",
                                    "data-toggle": "dropdown",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    Actions\n                                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "dropdown-menu dropdown-menu-right",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.showProjectPlanTemplateEditor(
                                            t
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Edit")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "dropdown-item",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteCorporateProjectPlanTemplateCommand(
                                            t
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Business case templates")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "align-top" }, [_vm._v("Template")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-top text-center" }, [
          _vm._v("Granularity"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-top text-center" }, [
          _vm._v("Denomination"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-top text-center" }, [
          _vm._v("Project execution"),
          _c("br"),
          _vm._v(" "),
          _c("small", { staticClass: "text-muted" }, [_vm._v("in months")]),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-top text-center" }, [
          _vm._v("Planning horizon"),
          _c("br"),
          _vm._v(" "),
          _c("small", { staticClass: "text-muted" }, [_vm._v("in years")]),
        ]),
        _vm._v(" "),
        _c("th", { staticStyle: { width: "120px" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }